import { getAdmins as apiGetAdmins, changeUsersRole } from "api/users";
import constate from "constate";
import { useFetchedState } from "hooks/useFetchedState";
import { type TAdminUser } from "models/UserModel";
import { useCallback } from "react";

const useAdmins = () => {
  const { data: admins, loadData: loadAdmins, setData: setAdmins } = useFetchedState(apiGetAdmins);

  const addAdmin = useCallback(
    async (userId: string) => {
      const adminUser = (await changeUsersRole(userId, "admin")) as TAdminUser;
      setAdmins((current) => (current ? current.set(adminUser.id, adminUser) : null));
    },
    [setAdmins],
  );

  const removeAdmin = useCallback(
    async (userId: string) => {
      const adminUser = (await changeUsersRole(userId, "regular")) as TAdminUser;
      setAdmins((current) => current!.remove(adminUser.id));
    },
    [setAdmins],
  );

  return {
    actions: { addAdmin, loadAdmins, removeAdmin },
    state: { admins },
  };
};

export const [AdminsProvider, useAdminsContext] = constate(useAdmins);
